export default "__VITE_ASSET__B4X3HgiP__"